import React from "react";
import {
  REACT_APP_CLOUD_FRONT,
  ROUTE_VIEW_ALL_LOCATIONS,
} from "../../constants";
import { useNavigate } from "react-router";

const NoLocation = ({
  scrollRef,
  styleClasses,
  zipCode,
  markets,
  handleMarkets,
  handleScroll,
  borderNone,
  isRedirectToAllLocationsPage,
}) => {
  const history = useNavigate();
  const handleShowLocations = (state: string) => {
    history(ROUTE_VIEW_ALL_LOCATIONS, {
      state: { stateName: state },
    });
  };

  const handleIsRedirectToAllLocationsPage = (locationId: number | string) => {
    if (isRedirectToAllLocationsPage && typeof locationId === "string") {
      return handleShowLocations(locationId);
      
    } else if (!isRedirectToAllLocationsPage && typeof locationId === "number") {
      return handleMarkets(locationId);
    } 
   
  };
  
  
  return (
    <React.Fragment>
      <ul
        className={`${styleClasses.not_find_states} list-inline font-Visby-cf ps-0 text-start mb-5 pt-0`}
      >
        {typeof markets !== "undefined" &&
          markets.map((market) => {
            return (
              <li
                className={`cursor font-Visby-cf f-w6 mb-1 f-s16 clr-dark-blue`}
                style={{ cursor: "pointer" }}
                onClick={() => handleIsRedirectToAllLocationsPage(isRedirectToAllLocationsPage ?  market.name : market.id)}
                key={market.name}
              >
                {market.name}
              </li>
            );
          })}
      </ul>
    </React.Fragment>
  );
};

export default NoLocation;
